var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRootControlDoubleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.9728C2 18.9728 2.78483 18.9694 4 18.8659C8.14701 18.5125 17.3059 16.9919 17.387 10.4539C17.4683 3.9028 8.18367 2.42828 4 2.0964C2.78483 2 2 2 2 2L2 18.9728ZM4 16.8582C4.06473 16.8524 4.13064 16.8462 4.19768 16.8397C5.56176 16.7083 7.34992 16.4516 9.11514 15.9575C10.9041 15.4568 12.5229 14.7522 13.6653 13.8091C14.7514 12.9125 15.3696 11.8446 15.3872 10.4291C15.4045 9.03053 14.816 7.98719 13.7525 7.10776C12.6265 6.17662 11.0085 5.47957 9.20472 4.98575C7.42676 4.49899 5.61897 4.24963 4.23761 4.12385C4.15676 4.11649 4.07753 4.10957 4 4.10305L4 16.8582Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86853 10.4253C7.86474 13.8134 6.2512 17.3113 2.91004 18.5776L2.55563 17.6425C5.3808 16.5718 6.86503 13.553 6.86853 10.4242C6.87202 7.29593 5.39508 4.27791 2.55621 3.2066L2.90928 2.271C6.26605 3.53775 7.87231 7.03681 7.86853 10.4253Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 13.046C30 13.046 29.2151 13.0494 28 13.153C23.8565 13.5063 14.7108 15.0258 14.6298 21.5556C14.5486 28.0984 23.8199 29.5719 28 29.9038C29.2151 30.0002 30 30.0002 30 30.0002V13.046ZM28 15.1607C27.9361 15.1665 27.8711 15.1725 27.8049 15.1789C26.4424 15.3102 24.6564 15.5666 22.8932 16.0601C21.1064 16.5602 19.4896 17.264 18.3488 18.2058C17.2643 19.1011 16.6472 20.1672 16.6296 21.5804C16.6123 22.9767 17.1998 24.0183 18.2617 24.8964C19.3862 25.8262 21.0021 26.5224 22.8037 27.0157C24.5796 27.5018 26.3853 27.7509 27.765 27.8765C27.845 27.8838 27.9233 27.8907 28 27.8971V15.1607Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1373 21.5841C24.1411 18.1996 25.753 14.7053 29.0908 13.4402L29.4452 14.3753C26.6234 15.4448 25.1408 18.46 25.1373 21.5852C25.1339 24.71 26.6091 27.7244 29.4446 28.7945L29.0915 29.7301C25.7381 28.4646 24.1336 24.9691 24.1373 21.5841Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootControlDoubleRight);
export default __webpack_public_path__ + "static/media/root-control-double-right.8eca8f29.svg";
export { ForwardRef as ReactComponent };